import { render, staticRenderFns } from "./Pagos2DetallesPago.vue?vue&type=template&id=6954ce3d&scoped=true"
import script from "./Pagos2DetallesPago.vue?vue&type=script&lang=js"
export * from "./Pagos2DetallesPago.vue?vue&type=script&lang=js"
import style0 from "./Pagos2DetallesPago.vue?vue&type=style&index=0&id=6954ce3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954ce3d",
  null
  
)

export default component.exports